class DecayChain {
    /**
     *
     * @param {Nuclide} nuclide
     * @param {Boolean} isSecondary
     */
    constructor(nuclide, isSecondary, isCircular = false) {
        this.isSecondary = isSecondary;
        this.nuclide = nuclide;
        this.daughters = [];
        this.isCircular = isCircular;
    }

    hasDaughter() {
        return this.daughters.length > 0;
    }

    /**
     * @param {DecayChain} daughter
     */
    addDaughter(daughter) {
        this.daughters.push(daughter);
    }
}

export default DecayChain;
